module.exports = __webpack_public_path__ + "img/art-24.612eace2.png";